import { configureStore } from "@reduxjs/toolkit";
import runningStatusSlice from "./Slice/runningStatusSlice";
import sandboxResultSlice from "./Slice/sandboxResultSlice";
import sandboxErrorSlice from "./Slice/sandboxErrorSlice";

const store = configureStore({
    reducer: {
        runningStatus: runningStatusSlice,
        sandboxResultsData: sandboxResultSlice,
        sandboxRunningError: sandboxErrorSlice,
    },
});
export default store;
